import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UpdateInvestmentHoldingRequest } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'
import { UpdateInvestmentHoldingResponse } from '@cash-web/shared-util-protos/squareup/franklin/investing.pb'

export const updateInvestmentHolding = (request: UpdateInvestmentHoldingRequest, options?: CashRequestOptions) =>
  post<UpdateInvestmentHoldingRequest, UpdateInvestmentHoldingResponse>(
    '/2.0/cash/update-investment-holding',
    request,
    { ...options, rejectOnError: true }
  )
